import React from 'react';
import {Button, Typography} from "@mui/material";
import {HeaderTitleBox, LicenseManagementHeaderWrapper} from "./LicenseManagementHeader.styled";
import {useTranslation} from "react-i18next";

interface LicenseManagementHeaderProps {
    onDeactivateLicense: () => void;
    deactivateBtnDisabled: boolean;
}

const LicenseManagementHeader = ({deactivateBtnDisabled, onDeactivateLicense}: LicenseManagementHeaderProps) => {
    const {t} = useTranslation();

    return (
        <LicenseManagementHeaderWrapper>
            <HeaderTitleBox>
                <Typography id="license-management-title" variant="h4" component="h2">
                    {t('licenseManager.header.title')}
                </Typography>

                <Typography variant="body1" component="p">
                    {t('licenseManager.header.subtitle')}
                </Typography>
            </HeaderTitleBox>

            <Button variant="outlined"
                    color="error"
                    type="button"
                    onClick={onDeactivateLicense}
                    disabled={deactivateBtnDisabled}
                    sx={{ flexShrink: 0 }}
            >
                {t('licenseManager.header.deactivateBtn')}
            </Button>
        </LicenseManagementHeaderWrapper>
    );
};

export default LicenseManagementHeader;